import { render, staticRenderFns } from "./component.vue?vue&type=template&id=67976b9f&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=67976b9f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67976b9f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/projects/pes-portal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67976b9f')) {
      api.createRecord('67976b9f', component.options)
    } else {
      api.reload('67976b9f', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=67976b9f&scoped=true&", function () {
      api.rerender('67976b9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/resource/component/project-timeline/component.vue"
export default component.exports